import React from "react";
import { connect } from "react-redux";
import actionWays from '../../../redux/actions';
import { withRouter } from 'react-router-dom'
import { MenuUnfoldOutlined } from '@ant-design/icons';
import { userInfoFunc } from '../../../config/func'
import { USERVALIDTIME } from '../../../config'
import './topBack.scss'
import { message, Modal, Form, Input, Button, Checkbox, Row, Col, Spin, Drawer } from "antd";
const homeTop = [    //登录以前
    // { name: '登录', links: '/login' },
    { name: '通用', links: '/general' },
    { name: '新闻', links: '/new' },
    { name: '图片管理', links: '/imgManage' },
    { name: '招聘管理', links: '/recruit' },
    { name: '申请试用', links: '/applyFor' },
    { name: '退出', links: '/' },
    // { name: '房源项目', links: '/project' },
    // { name: '区筹资格申请', links: '/areatoraise' },
    // { name: '登录', links: '' },
    // { name: '注册', links: '' },
]
const homeTopLogin = [    //登录以后
    { name: '首页', links: '/home' },
    { name: '房源项目', links: '/project' },
    { name: '区筹资格申请', links: '/areatoraise' },
    { name: '个人中心', links: '/personal' },
    { name: '退出', links: '' },
]
class Top extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            needFixed: false,
            currentIndex: localStorage.currentIndex ? localStorage.currentIndex : 0,
            isModalVisible: false,
            loading: false,
            personal: userInfoFunc(props.userLoginInfo) ? '1' : '0',
            loginLoading: false,
            signView: false,
            timer: 60,
            drawerVisible: false
        }
        this.timers = null
    }
    componentDidMount () {
        const { currentIndex } = this.state

        if (!this.props.userLoginInfo) {
            message.error('请先登录')
            this.props.history.push({ pathname: '/login' })
        }
        window.addEventListener('scroll', this.handleScroll);
        // debugger
        if (userInfoFunc(this.props.userLoginInfo)) {
            if (this.props.location.pathname !== '/belows') {
                for (let i in homeTopLogin) {
                    if (homeTopLogin[i].links === this.props.location.pathname) {
                        this.setState({
                            currentIndex: i
                        })
                    }
                }
            }
        } else {
            for (let i in homeTop) {
                if (homeTop[i].links === this.props.location.pathname) {
                    this.setState({
                        currentIndex: i
                    })
                }
            }
        }
        // console.log(localStorage.currentIndex)
        // this.elect(currentIndex, homeTop[currentIndex].links)
        this.user_time()
    }
    componentWillUnmount () {
        clearInterval(this.timers)
        this.setState = () => false;
    }
    user_time = () => {
        if (this.props.userLoginInfo) {
            //获取用户登录时间
            let strtime = localStorage.getItem('user_time')
            if (strtime) {
                //计算过期时间
                let vaildtime = Number(strtime) + USERVALIDTIME
                let timespan = Date.parse(new Date())
                if (timespan < vaildtime) {
                } else {
                    this.props.saveLoginInfo(null);
                }
            }
        }
    }

    handleScroll = () => {
        let _self = this
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
        if (scrollTop > 0) {
            _self.setState({
                needFixed: true
            })
        } else {
            _self.setState({
                needFixed: false
            })
        }
    }



    elect = async (index, item) => {
        console.log(item)
        if (item.name !== '登录' && item.name !== '注册' && item.name !== '退出') { //eslint-disable-line

            localStorage.setItem("currentIndex", index)
            this.setState({
                currentIndex: index,
                drawerVisible: false
            })
            this.props.history.push({ pathname: item.links, query: {} })
        } else {
            // eslint-disable-next-line default-case
            switch (item.name) {
                case '登录': {
                    this.setState({
                        isModalVisible: true,
                        signView: false
                    })
                    break;
                }
                case '退出': {
                    this.setState({
                        loginLoading: true,
                        drawerVisible: false
                    })
                    this.loginOut()
                    break;
                }
                case '注册': {
                    this.setState({
                        isModalVisible: true,
                        signView: false
                    })
                    this.sign(true)
                    break;
                }

            }
        }
    }
    loginOut = () => {
        this.props.saveLoginInfo(null);
        setTimeout(() => {
            this.setState({
                loginLoading: false,
                personal: '0'
            })
        })
        message.success('已退出')
        this.props.history.push('/login')
    }
    tableBody = (item, index) => {
        const { currentIndex } = this.state
        return (
            <li key={index} ><a style={{ color: '#000' }} className={currentIndex == index//eslint-disable-line
                ? 'elect' : ''} onClick={() => { this.elect(index, item) }}>{item.name}</a></li>
        );
    }


    sign = (key) => {
        this.setState({
            signView: key
        })
    }


 

  
    visibleHand = () => {
        this.setState({
            drawerVisible: true
        })
    }


    render () {
        return (
            <div id='topId' className={ 'row rowbackgroundView'}>

                <div className="col-lg-2"></div>
                <div className='col-lg-8'>
                    <nav style={{ marginBottom: '0', background: 'none', border: 'none', color: '#fff' }} className={'colorFixed navbar navbar-default'}>
                        <div className="container-fluid">
                            <div className="navbar-header" style={{ lineHeight: '60px',cursor:'pointer' }} onClick={()=>{this.props.history.push({ pathname: '/home',})}}>
                                <button type="button" className="fr navbar-toggle" style={{ border: 'none', margin: '0', padding: '0 1em 0 0', background: 'none' }} data-toggle="collapse"
                                    data-target="#bs-example-navbar-collapse-1" aria-expanded="false" onClick={() => { this.visibleHand() }}>
                                    <MenuUnfoldOutlined style={{ width: '1.6em', fontSize: '1.3em' }} />
                                </button>
                                <div id="logoImg"></div>
                                <div id="nameImg"></div>
                            </div>
                            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                                <ul className={'colorFixed nav navbar-nav navbar-right' }>
                                    {homeTop.length > 0 ?
                                        homeTop.map(this.tableBody) : null
                                    }
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
                <div className="col-lg-2"></div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Top))
